import styled, { css } from 'styled-components'
import LoginMethodForm from 'src/forms/LoginMethodForm'

import ActionButton from '../ActionButton'
import Link from '../Link'
import Icon from '../Icon'
import { mq, sizes } from '../../theme'

export const Block = styled.div`
  background-color: ${({ theme }) => theme.colors.brownBack};
  padding: 3rem;
`

export const TopBlock = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  margin-bottom: 3rem;
`

export const Email = styled.span`
  display: inline-block;
  ${({ theme }) => theme.textStyles.firaSansLg};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-top: 4rem;

  @media ${mq(sizes.tablet)} {
    margin-top: 0;
  }
`

export const Form = styled(LoginMethodForm)``

export const Wrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up('tablet')} {
    display: flex;
  }

  justify-content: center;
`

export const Button = styled(ActionButton)`
  align-self: center;
  height: 4rem;
`

export const _Link = styled(Link)`
  align-self: flex-start;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-top: 3rem;
`

export const TopLink = styled(Link)`
  position: absolute;
  left: 0;
  align-self: flex-start;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.bluePrimary};
`

export const BackLinkIcon = styled(Icon)`
  margin-right: 1rem;
`

export const Title = styled.h3<{ $centered?: boolean }>`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-bottom: 4rem;
  margin-top: 0;

  ${({ $centered }) =>
    $centered &&
    css`
      text-align: center;
    `};
`
